import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { sync } from "vuex-router-sync";

import { router } from "@/router";
import { app } from "./app";
import { user } from "./user";
import { productionLines } from "./productionlines";
import { security } from "./security";
import { receptions } from "./receptions";
import { transporters } from "./transporters";
import { components } from "./components";
import { expeditions } from "./expeditions";
import { suppliers } from "./suppliers";
import { otherAppointments } from "./otherAppointments";
import { saleOrders } from "./saleOrders";
import { slots } from "./slots";

Vue.use(Vuex);

// Create root store
const options: StoreOptions<any> = {
    strict: process.env.NODE_ENV !== "production",
    modules: {
        app,
        user,
        productionLines,
        security,
        receptions,
        transporters,
        components,
        expeditions,
        suppliers,
        otherAppointments,
        saleOrders,
        slots,
    },
};

const store = new Vuex.Store(options);

// Sync with vue-router
sync(store, router);

export { store };
